<template>

    <div class="container-fluid p-0 m-0 pb-3 position-relative">
      <div class="vintiu">
        <img :src="`${publicPath}img/vintiu.png`" data-aos-delay="3000" data-aos="fade-left" data-aos-duration="3000" class="img-responsive">
      </div>
      <div class="visor m-0 p-0">

        <div class="row filaA">
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_01.jpg`" data-aos-delay="100" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_02.jpg`" data-aos-delay="1500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_03.jpg`" data-aos-delay="800" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_04.jpg`" data-aos-delay="2000" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_05.jpg`" data-aos-delay="3000" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_06.jpg`" data-aos-delay="1000" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F1_07.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
        </div>

      </div>
      <div class="visor overflow-hidden m-0 p-0">

        <div class="row filaB">
          <div class="col img-home">{{randomNumber}}
            <img :src="`${publicPath}img/F2_01.jpg`" data-aos-delay="3100" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_02.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_03.jpg`" data-aos-delay="2800" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_04.jpg`" data-aos-delay="2500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_05.jpg`" data-aos-delay="300" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_06.jpg`" data-aos-delay="100" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F2_07.jpg`" data-aos-delay="1500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
        </div>

      </div>
      <div class="visor overflow-hidden m-0 p-0">

        <div class="row filaA">
          <div class="col img-home">{{randomNumber}}
            <img :src="`${publicPath}img/F3_01.jpg`" data-aos-delay="1900" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_02.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_03.jpg`" data-aos-delay="1800" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_04.jpg`" data-aos-delay="1500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_05.jpg`" data-aos-delay="500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_06.jpg`" data-aos-delay="5000" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F3_07.jpg`" data-aos-delay="3500" data-aos="fade" data-aos-duration="1500" class="img-responsive">
          </div>
        </div>

      </div>
      <div class="visor overflow-hidden m-0 p-0">

        <div class="row filaB">
          <div class="col img-home">{{randomNumber}}
            <img :src="`${publicPath}img/F4_01.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_02.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_03.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_04.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_05.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_06.jpg`" class="img-responsive">
          </div>
          <div class="col img-home">
            <img :src="`${publicPath}img/F4_07.jpg`" class="img-responsive">
          </div>
        </div>

      </div>
    </div>

</template>

<script>
export default {
  name: "HomeView",
  data() {
      return {
          publicPath: process.env.BASE_URL,
          isEs: this.$i18n.locale=='es' ? true : false,
          isEn: this.$i18n.locale=='en' ? true : false,

      }
  },
};
</script>

